export const STORE_NAME = "GamesTrade Flagship Store";
export const STORE_ADDRESS = "Spectrum Mall LG-109, Sector 75, Noida";
export const STORE_ADDRESS_LINES = ["Spectrum Mall LG-109", "Sector 75, Noida"];
export const STORE_PHONE = "+91 82877 99290";
export const STORE_PHONE_HREF = "tel:+918287799290";
export const STORE_WHATSAPP = "https://wa.me/918287799290";
export const STORE_EMAIL = "gamestradenoida@gmail.com";
export const STORE_EMAIL_HREF = `mailto:${STORE_EMAIL}`;
export const STORE_HOURS = "10 AM - 9 PM, all days";
export const STORE_MAPS_LINK = "https://maps.app.goo.gl/qymMu3i5xAc9j7rFA";
export const STORE_MAP_EMBED =
  "https://www.google.com/maps?q=GamesTrade%20Spectrum%20Mall%20LG-109%20Sector%2075%20Noida&output=embed";
export const STORE_IMAGE = "/store-noida.jpg";
